import styled from 'styled-components';

const ThumbStyles = styled.div``;

export default ThumbStyles;
